export default __webpack_public_path__ + "static/Moniqa-MediumParagraph-fe42bf2c0b22fad7c698d0dc27dcf620.woff2";